module.exports = __webpack_public_path__ + "static/media/outer_13.1110f2df.jpg";